import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { readRequestDraft, saveRequestDraft } from "./requestDraftSession";
import "./RequestFlow.scss";
import WizardSteps from "./WizardSteps";

export default function RequestDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [description, setDescription] = useState("");
  const [insurance, setInsurance] = useState("");

  useEffect(() => {
    const draft = readRequestDraft(id);
    setDescription(String(draft.description || ""));
    setInsurance(String(draft.insurance || ""));
  }, [id]);

  const onContinue = () => {
    saveRequestDraft(id, { description: description.trim(), insurance: insurance.trim() });
    navigate(`/request/${id}/review`);
  };

  return (
    <section className="reqWizard">
      <div className="reqWizard__card">
        <button
          type="button"
          className="reqWizard__back reqWizard__back--dupGlobalNav"
          onClick={() => navigate(`/request/${id}/budget`)}
        >
          <ArrowLeft size={16} />
          Back
        </button>
        <p className="reqWizard__eyebrow">New care request</p>
        <h1 className="reqWizard__title">Tell us what you need</h1>
        <p className="reqWizard__subtitle">
          Upload documents and pick the exact procedure. Doctors see your request only after linked documents are approved.
        </p>
        <WizardSteps active={3} />

        <h2 className="reqWizard__sectionTitle">Add a few details</h2>
        <label className="reqWizard__label" htmlFor="req-desc">Describe your situation</label>
        <textarea
          id="req-desc"
          className="reqWizard__textarea"
          placeholder="Symptoms, duration, prior treatments, anything doctors should know..."
          maxLength={600}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <p className="reqWizard__sectionSub">{description.length}/600 characters</p>

        <label className="reqWizard__label" htmlFor="req-ins">Insurance provider (optional)</label>
        <input
          id="req-ins"
          className="reqWizard__input"
          placeholder="e.g. Star Health, HDFC Ergo, ICICI Lombard"
          value={insurance}
          maxLength={160}
          onChange={(e) => setInsurance(e.target.value)}
        />

        <div className="reqWizard__actions">
          <button
            type="button"
            className="reqWizard__ghost reqWizard__ghost--dupWithCardBack"
            onClick={() => navigate(`/request/${id}/budget`)}
          >
            Back
          </button>
          <button type="button" className="reqWizard__primary" disabled={description.trim().length <= 10} onClick={onContinue}>
            Continue
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}
